import {Fragment, PureComponent} from 'react'
import {Link} from 'react-router-dom'
import {TabContent, TabPane} from 'reactstrap'

import DefaultLayout from '../Layout/DefaultLayout.jsx'
import IllustratedDiv from '../../components/IllustratedDiv/IllustratedDiv.jsx'

import {generate} from '../../routes.js'

import numbr from '../../media/images/partnerships/logo-numbr.svg'
import embarq from '../../media/images/partnerships/logo-embarq.svg'
import statusesImg from './images/statuses.jpg?size=600'
import salaryImg from './images/salary.jpg?size=600'

import './Partnerships.scss'

export default class Partnerships extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      activeTab: 'embarq'
    }
  }

  render() {
    const title = 'Twineeds | Nos partenaires vous accompagnent'
    const description = 'Découvrez nos partenaires pour votre activité de consultant ou freelance. Twineeds offre flexibilité et accompagnement personnalisé en fonction de votre statut.'

    const titles = {
      who: 'Qui sont-ils ?',
      what: 'Que font-ils ?',
      dont: 'Ce qu\'ils ne font pas ?',
      why: 'Pourquoi ce partenariat ?',
      twineedsBenefit: 'Avantage Twineeds',
      price: 'Tarifs pratiqués',
      benefit: 'Avantage du modèle',
      target: 'Pour qui ?',
      contact: 'Contact',
      simulation: 'Simulez votre revenu sous le modèle',
    }

    const partners = [
      {
        key: 'embarq',
        label: 'Embarq',
        logo: embarq,
        altText: 'Embarq : La vie d’indépendant et le confort du salariat',
        who: <p>Un cabinet de <strong><Link to={generate({name: 'blog-article', parameters: {slug: 'le-portage-salarial-qu-est-ce-que-c-est'}})} className="is-underline" target="_blank" rel="noopener noreferrer">portage salarial</Link></strong></p>,
        what: <p>Ils transforment un chiffre d'affaires en un bulletin de salaire contre un pourcentage de votre CA</p>,
        dont: <p>Les cabinets de portage salarial ont l'interdiction d'exercer toute autre activité, et donc de trouver
          des missions pour le compte de leurs clients</p>,
        why: <ul>
          <li>Porteur salarial très efficace et réactif</li>
          <li>Des prix compétitifs</li>
        </ul>,
        twineedsBenefit: <p>Avance de salaire offerte</p>,
        price: <p>6% du CA (plafonnés à 600€ par mois)</p>,
        benefit: <ul>
          <li>Le portage salarial permet de continuer à cotiser tout comme un salarié "classique"</li>
          <li>Vous conservez vos droits au chômage</li>
          <li>Démarrage d'une mission en 48h possible</li>
          <li>Aucun administratif</li>
        </ul>,
        target: <Fragment>
          <p className="font-weight-bold text-secondary">Le portage est très adapté :</p>
          <ul>
            <li>
              Si vous souhaitez continuer à cotiser pour vos droits au chômage ou parce que vous êtes proche de la
              retraite
            </li>
            <li>Si vous souhaitez n'avoir aucune charge administrative</li>
            <li>Si vous n'avez pas forcément vocation à rester consultant ou faire des missions</li>
            <li>Si vous êtes en cours de création d'entreprise</li>
          </ul>
        </Fragment>,
        contact: <a
          className="btn btn-primary" href="https://www.embarq.fr/contact" rel="noopener noreferrer" target="_blank"
        >
          Contacter Embarq
        </a>,
        simulation: <a
          className="btn btn-primary"
          href="https://www.embarq.fr/simulation-portage-salarial"
          rel="noopener noreferrer"
          target="_blank"
        >
          En savoir plus
        </a>
      },
      {
        key: 'numbr',
        label: 'Numbr',
        logo: numbr,
        altText: 'Numbr, libres d\'entreprendre !',
        who: <p>Un expert comptable spécialiste des freelances</p>,
        what: <ul>
          <li>Ils gèrent votre comptabilité, vos factures, vos frais</li>
          <li>Optimisent fiscalement vos revenus</li>
          <li>Vous aident à créer votre société si besoin</li>
        </ul>,
        dont: <p>En tant qu'Expert Comptable, Numbr n'a pas pour vocation de trouver des missions ou clients à ses
          propres clients</p>,
        why: <ul>
          <li>Permet d'avoir sa propre société sans s'occuper de l'administratif</li>
          <li>Des prix compétitifs</li>
          <li>Accès à des applications pour faciliter grandement la gestion</li>
        </ul>,
        twineedsBenefit: <p>Création d'entreprise offerte (hors frais de tiers)</p>,
        price: <p>Package à environ 150€ par mois (incluant compte bancaire, conseils, bilan...)</p>,
        benefit: <ul>
          <li>
            Monter sa structure permet gérer ses frais, le rythme de ses revenus, et globalement de tirer un maximum du
            revenu de ses missions
          </li>
          <li>La charge administrative existe MAIS est très fortement réduite grâce au partenaire</li>
        </ul>,
        target: <Fragment>
          <p className="font-weight-bold text-secondary">Créer une société est très adapté si :</p>
          <ul>
            <li>Si vous avez pour projet de rester consultant indépendant quelques années</li>
            <li>Si vous souhaitez optimiser vos revenus (frais et fiscalité)</li>
            <li>Si vous souhaitez gérer les fluctuations de revenu</li>
          </ul>
        </Fragment>,
        contact: <a
          className="btn btn-primary" href="https://numbr.co/nous-contacter/" rel="noopener noreferrer" target="_blank"
        >
          Contacter Numbr
        </a>,
        simulation: <a className="btn btn-primary"
          href="https://numbr.co/rendez-vous-ville/"
          rel="noopener noreferrer"
          target="_blank"
        >
          En savoir plus
        </a>
      }
    ]

    return <DefaultLayout showSidebarMenu={false} id="partnerships" helmet={{title, description}}>
      <div className="bg-light">
        <section className="container py-5">
          <h1 className="text-center mb-3">Nos partenaires vous accompagnent</h1>
          <p>Twineeds met à disposition des <strong>partenaires de confiance pour accompagner les consultants indépendants</strong> dans la <strong><Link to={generate({name: 'blog-article', parameters: {slug: 'quelle-structure-choisir-pour-etre-consultant-independant'}})} className="is-underline" target="_blank" rel="noopener noreferrer">création de leur structure</Link></strong>, la gestion administrative et l'optimisation de leur activité.</p>
          <p>Voici <strong>quelques précisions importantes</strong> avant toute chose :</p>
          <ul className="mb-4 mb-md-5">
            <li>
              <strong>
                Vous n'avez pas besoin d'avoir fait le choix de votre structure pour travailler avec Twineeds
              </strong> (vous aurez le temps de gérer cela une fois une mission démarrée).
            </li>
            <li>
              <strong>Vous pouvez travailler avec d'autres partenaires de votre choix</strong>, ce ne sont que des
              recommandations.
            </li>
            <li>Le <strong><Link to={generate({name: 'blog-article', parameters: {slug: 'les-statuts-des-consultants-independants'}})} className="is-underline" target="_blank" rel="noopener noreferrer">choix d'un statut</Link></strong> n'est pas définitif.</li>
          </ul>
          <div className="comparison d-none d-lg-block">
            <div className="row">
              {partners.map((partner, index) => {
                const className = ['col-5', 'd-flex', 'align-items-stretch']
                if (index === 0) {
                  className.push('offset-2')
                }

                return <div className={className.join(' ')} key={partner.key}>
                  <div className="bg-white flex-grow-1 p-3 text-center">
                    <img className="w-50" src={partner.logo} alt={partner.altText}/>
                  </div>
                </div>
              })}
            </div>
            {Object.entries(titles).map(([key, label]) => (
              <div className="row" key={key}>
                <p className="col-2 d-flex align-items-center text-secondary font-weight-bold">{label}</p>
                {partners.map((partner) => (
                  <div className="col-5 d-flex align-items-stretch" key={partner.key}>
                    <div className="bg-white flex-grow-1 d-flex px-5 text-center">
                      <div className="top-border d-flex w-100 align-items-center justify-content-center">
                        <div className="py-4 w-100">{partner[key]}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
          <div className="bg-white d-lg-none p-4">
            <div className="btn-group d-flex justify-content-center" role="group">
              {partners.map((partner) => (
                <button
                  aria-controls={`tab-${partner.key}`}
                  aria-selected={this.state.activeTab === partner.key}
                  className={`nav-link btn ${this.state.activeTab === partner.key ? 'btn-primary' : 'btn-outline-primary'}`}
                  id={`${partner.key}-pill`}
                  key={partner.key}
                  onClick={() => this.setState({activeTab: partner.key})}
                  type="button"
                  role="tab"
                >
                  {partner.label}
                </button>
              ))}
            </div>
            <TabContent activeTab={`tab-${this.state.activeTab}`}>
              {partners.map((partner) => (
                <TabPane tabId={`tab-${partner.key}`} key={partner.key}>
                  {Object.entries(titles).map(([key, label]) => (
                    <div className="mt-3" key={key}>
                      <p className="font-weight-bold text-secondary">{label}</p>
                      {partner[key]}
                    </div>
                  ))}
                </TabPane>
              ))}
            </TabContent>
          </div>
        </section>
      </div>

      <section className="container py-5">
        <IllustratedDiv imgAlt="Les différents types de statuts" imgSrc={statusesImg.src}>
          <h2 className="mb-3">Quel statut choisir pour se lancer dans l'indépendance ?</h2>
          <p>Le <strong><Link to={generate({name: 'blog-article', parameters: {slug: 'quelle-structure-choisir-pour-etre-consultant-independant'}})} className="is-underline" target="_blank" rel="noopener noreferrer">choix de votre statut juridique</Link></strong> (auto-entrepreneur, SASU, portage salarial...) a un impact direct sur votre fiscalité, vos revenus et votre protection sociale.</p>
          <p>Consultez notre article dédié pour y découvrir les avantages et inconvénients de chaque structure !</p>
          <Link
            className="btn btn-primary"
            to={generate({name: 'blog-article', parameters: {slug: 'les-statuts-des-consultants-independants'}})}>
              Découvrir l'article
          </Link>
        </IllustratedDiv>
        <IllustratedDiv imgAlt="Chiffre d'affaire et TJ : tout savoir sur la rémunération" imgSrc={salaryImg.src}>
          <h2 className="mb-3">Chiffre d'affaire et TJ : tout savoir sur la rémunération</h2>
          <p>
            Vous souhaitez en savoir plus sur la rémunération du consultant indépendant selon le type de structure ?
          </p>
          <p>Découvrez les différents cas de figure à travers des simulations.</p>
          <Link
            className="btn btn-primary"
            to={generate({
              name: 'blog-article',
              parameters: {slug: 'comprendre-et-definir-revenu-consultant'}
            })}>
            Découvrir l'article
          </Link>
        </IllustratedDiv>
      </section>
    </DefaultLayout>
  }
}
